<!--
 * @Author: RYL
 * @Description: 
 * @Date: 2020-10-28 11:41:38
 * @LastEditTime: 2022-03-03 10:43:55
-->
<template>
  <div v-if="dialogVisible">
    <el-dialog
      :title="
        type === 'edit'
          ? $t('lang.alarmContact.EditContact')
          : $t('lang.alarmContact.Addcontacts')
      "
      :visible.sync="dialogVisible"
      center
      append-to-body
    >
      <div class="contact-form">
        <el-form
          :model="contactForm"
          ref="contactForm"
          :rules="rules"
          label-width="120px"
          label-position="right"
        >
          <el-form-item :label="$t('lang.alarmContact.name')" prop="name">
            <el-input
              v-model="contactForm.name"
              size="mini"
              clearable
              class="form-input"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('lang.alarmContact.phone')" prop="phone">
            <el-tag
              class="tag-style"
              :key="tag"
              v-for="(tag, index) in phoneList"
              @close="phoneClose(index)"
              closable
            >
              {{ tag }}
            </el-tag>
            <el-input
              v-if="phoneInput"
              v-model="phoneInputValue"
              size="mini"
              clearable
              ref="phoneInput"
              @blur="confirmPoneInput"
              @keyup.enter.native="confirmPoneInput"
              class="form-input"
            >
            </el-input>
            <el-button
              type="primary"
              v-else
              size="small"
              plain
              @click="showPoneInput"
              >+ {{ $t("lang.alarmContact.new") }}</el-button
            >
          </el-form-item>
          <el-form-item :label="$t('lang.alarmContact.email')" prop="email">
            <el-tag
              class="tag-style"
              :key="tag"
              v-for="(tag, index) in emailList"
              @close="emailClose(index)"
              closable
            >
              {{ tag }}
            </el-tag>
            <el-input
              v-if="emailInput"
              v-model="emailInputValue"
              size="mini"
              clearable
              ref="emailInput"
              @blur="confirmEmailInput"
              @keyup.enter.native="confirmEmailInput"
              class="form-input"
            >
            </el-input>
            <el-button
              type="primary"
              v-else
              size="small"
              plain
              @click="showEmailInput"
              >+ {{ $t("lang.alarmContact.new") }}</el-button
            >
          </el-form-item>
          <el-form-item :label="$t('lang.alarmContact.wechat')" prop="wechat">
            <el-input
              v-model="contactForm.wechat"
              size="mini"
              clearable
              class="form-input"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('lang.alarmContact.Remark')" prop="remark">
            <el-input
              type="textarea"
              :rows="2"
              v-model="contactForm.remark"
              size="mini"
              clearable
              class="form-input"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button size="mini" @click="dialogVisible = false">{{
          $t("lang.Button.cancel")
        }}</el-button>
        <el-button size="mini" type="primary" @click="submitForm">{{
          $t("lang.Button.confirm")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  addAlarmContact,
  editAlarmContact,
} from "@/api/cloudMonitor/alarmList";
import { getuser_id } from "@/localStorage/localStorage";
export default {
  data() {
    var checkPone = (rule, value, callback) => {
      if (this.phoneList.length <= 0) {
        callback(new Error(this.$t("lang.alarmContact.msg1")));
      } else {
        callback();
      }
    };
    var checkEmail = (rule, value, callback) => {
      if (
        this.emailList.length <= 0 &&
        !/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(this.emailList)
      ) {
        callback(new Error(this.$t("lang.alarmContact.msg2")));
      } else {
        callback();
      }
    };
    return {
      dialogVisible: false,
      // 正则 当以+号开头时后面的必须为数字且不可以超过11位不可以少于8位，当不是以+号开头时后面的必须为数字且不可以超过11位不可以少于8位
      reg: /^(\+)?\d{8,11}$/,
      type: "",
      contactForm: {
        uid: "",
        name: "",
        phone: "",
        email: "",
        wechat: "",
        remark: "",
      },
      emailList: [], // 邮箱
      phoneList: [], //手机号
      emailInput: false,
      phoneInput: false,
      phoneInputValue: "",
      emailInputValue: "",
      rules: {
        name: [
          {
            required: true,
            message: this.$t("lang.alarmContact.msg3"),
            trigger: "blur",
          },
        ],
        phone: [
          { required: true, validator: checkPone, trigger: ["blur", "change"] },
        ],
        email: [
          {
            required: true,
            validator: checkEmail,
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  methods: {
    cleatData() {
      this.contactForm = {
        name: "",
        phone: "",
        email: "",
        wechat: "",
        remark: "",
      };
      this.emailList = [];
      this.phoneList = [];
      this.emailInput = false;
      this.phoneInput = false;
      this.phoneInputValue = "";
      this.emailInputValue = "";
    },
    show(item) {
      this.cleatData();
      if (item) {
        this.type = "edit";
        this.contactForm = item;
        // 处理邮箱和手机号
        this.emailList = this.contactForm.email
          ? this.contactForm.email.split("，")
          : [];
        this.phoneList = this.contactForm.phone
          ? this.contactForm.phone.split("，")
          : [];
      } else {
        this.contactForm.uid = getuser_id();
        this.type = "add";
      }
      this.dialogVisible = true;
    },
    // 新增手机号
    showPoneInput() {
      this.phoneInput = true;
      this.$nextTick(() => {
        this.$refs.phoneInput.focus();
      });
    },
    // 离开手机号输入框焦点
    confirmPoneInput() {
      // 有值就先把值存进phoneList中
      if (this.phoneInputValue) {
        // 手机号已经存在
        let findResult = this.phoneList.find((item) => {
          return item.trim() === this.phoneInputValue.trim();
        });
        if (findResult) {
          this.$message.warning(this.$t("lang.alarmContact.msg4"));
          //this.phoneInputValue 必须以+号开头，不能少于8为数字
        } else if (! /^(\+)?\d{8,11}$/.test(this.phoneInputValue)) {
          this.$message({
            type: "error",
            message: this.$t("lang.alarmContact.msg5"),
          });
        } else {
          this.phoneList.push(this.phoneInputValue);
        }
      }
      this.phoneInput = false;
      this.phoneInputValue = "";
    },
    // 删除手机号
    phoneClose(index) {
      this.phoneList.splice(index, 1);
    },
    // 新增邮箱
    showEmailInput() {
      this.emailInput = true;
      this.$nextTick(() => {
        this.$refs.emailInput.focus();
      });
    },
    // 离开邮箱输入框焦点
    confirmEmailInput() {
      // 有值就先把值存进phoneList中
      if (this.emailInputValue) {
        // 邮箱已经存在
        let findResult = this.emailList.find((item) => {
          return item.trim() === this.emailInputValue.trim();
        });
        if (findResult) {
          this.$message.warning(this.$t("lang.alarmContact.msg6"));
        } else {
          if(!/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(this.emailInputValue)){
            return this.$message.warning(this.$t('lang.alarmContact.Emaildoesnot'))
          }
          this.emailList.push(this.emailInputValue);
        }
      }
      this.emailInput = false;
      this.emailInputValue = "";
    },
    // 删除邮箱
    emailClose(index) {
      this.emailList.splice(index, 1);
    },
    submitForm() {
      this.$refs.contactForm.validate((valid) => {
        if (valid) {
          this.contactForm.phone = this.phoneList.join("，");
          this.contactForm.email = this.emailList.join("，");
          if (this.type === "edit") {
            editAlarmContact(this.contactForm)
              .then((res) => {
                if (res.data.code === 0) {
                  this.$message.success(this.$t("lang.alarmContact.msg7"));
                  this.$emit("updateList");
                  this.dialogVisible = false;
                } else {
                  this.$message.error(this.$t("lang.alarmContact.msg8"));
                }
              })
              .catch(() => {});
          } else {
            addAlarmContact(this.contactForm)
              .then((res) => {
                if (res.data.code === 0) {
                  this.$message.success(this.$t("lang.alarmContact.msg9"));
                  this.$emit("updateList");
                  this.dialogVisible = false;
                } else {
                  this.$message.error(this.$t("lang.alarmContact.msg10"));
                }
              })
              .catch(() => {});
          }
        }
      });
    },
  },
};
</script>
<style scoped>
.contact-form {
  display: flex;
  justify-content: center;
}
.tag-style {
  margin-right: 10px;
}
.form-input {
  width: 4rem;
}
</style>
